import { MaskedLines } from "@/components/site/Reveal";
import { motion } from "framer-motion";

// Editorial header used across interior pages.
export default function PageHeader({ overline, title, titleLines, intro }) {
  const lines = titleLines || [title];
  return (
    <header className="max-w-[1400px] mx-auto px-5 md:px-10 pt-32 md:pt-44 pb-12 md:pb-20">
      {overline && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="overline mb-6"
          data-testid="page-overline"
        >
          {overline}
        </motion.p>
      )}
      <h1
        className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.92] tracking-tight max-w-5xl"
        data-testid="page-title"
      >
        <MaskedLines lines={lines} />
      </h1>
      {intro && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-8 md:mt-12 text-lg md:text-xl text-[#5c5c5c] max-w-2xl leading-relaxed md:ml-auto md:mr-0"
        >
          {intro}
        </motion.p>
      )}
    </header>
  );
}
